import { AirMeltIndustryInfo } from "../schema-types";

export const airMeltCmOptions = {
  category: "Cannon-Muskegon Title",
  options: [
    {
      label: "1020",
      value: "1020"
    },
    {
      label: "1025",
      value: "1025"
    },
    {
      label: "1030",
      value: "1030"
    },
    {
      label: "1040",
      value: "1040"
    },
    {
      label: "1050",
      value: "1050"
    },
    {
      label: "2512 MOD",
      value: "2512 MOD"
    },
    {
      label: "4020",
      value: "4020"
    },
    {
      label: "4020 MOD",
      value: "4020 MOD"
    },
    {
      label: "4115 MOD.",
      value: "4115 MOD."
    },
    {
      label: "4118 MOD.",
      value: "4118 MOD."
    },
    {
      label: "4130",
      value: "4130"
    },

    {
      label: "4140",
      value: "4140"
    },
    {
      label: "4330",
      value: "4330"
    },
    {
      label: "4335 MOD.",
      value: "4335 MOD."
    },
    {
      label: "4340",
      value: "4340"
    },

    {
      label: "4620",
      value: "4620"
    },
    {
      label: "6150",
      value: "6150"
    },
    {
      label: "8615",
      value: "8615"
    },
    {
      label: "E8620",
      value: "E8620"
    },

    {
      label: "8630",
      value: "8630"
    },
    {
      label: "8635 MOD.",
      value: "8635 MOD."
    },
    {
      label: "8640",
      value: "8640"
    },
    {
      label: "52100",
      value: "52100"
    },

    {
      label: "A-2",
      value: "A-2"
    },
    {
      label: "D-2",
      value: "D-2"
    },
    {
      label: "D-5",
      value: "D-5"
    },
    {
      label: "H-11",
      value: "H-11"
    },
    {
      label: "H-12",
      value: "H-12"
    },
    {
      label: "H-13",
      value: "H-13"
    },
    {
      label: "M-2",
      value: "M-2"
    },
    {
      label: "M-4",
      value: "M-4"
    },
    {
      label: "M-42",
      value: "M-42"
    },
    {
      label: "M-43",
      value: "M-43"
    },
    {
      label: "O-1",
      value: "O-1"
    },
    {
      label: "O-2",
      value: "O-2"
    },
    {
      label: "S-2",
      value: "S-2"
    },
    {
      label: "S-5",
      value: "S-5"
    },
    {
      label: "S-7",
      value: "S-7"
    },
    {
      label: "T-1",
      value: "T-1"
    },
    {
      label: "T-15",
      value: "T-15"
    },
    {
      label: "14-4",
      value: "14-4"
    },
    {
      label: "15-5",
      value: "15-5"
    },

    {
      label: "17-4",
      value: "17-4"
    },

    {
      label: "AM 355",
      value: "AM 355"
    },
    {
      label: "302",
      value: "302"
    },

    {
      label: "303",
      value: "303"
    },
    {
      label: "304",
      value: "304"
    },
    {
      label: "304 L",
      value: "304 L"
    },
    {
      label: "305 L",
      value: "305 L"
    },

    {
      label: "309",
      value: "309"
    },

    {
      label: "310",
      value: "310"
    },

    {
      label: "311",
      value: "311"
    },
    {
      label: "312",
      value: "312"
    },

    {
      label: "316",
      value: "316"
    },

    {
      label: "316 L",
      value: "316 L"
    },
    {
      label: "317 L",
      value: "317 L"
    },
    {
      label: "318 L",
      value: "318 L"
    },
    {
      label: "316 LN",
      value: "316 LN"
    },
    {
      label: "316 N",
      value: "316 N"
    },
    {
      label: "317",
      value: "317"
    },
    {
      label: "321",
      value: "321"
    },
    {
      label: "327",
      value: "327"
    },
    {
      label: "330",
      value: "330"
    },

    {
      label: "331",
      value: "331"
    },
    {
      label: "334",
      value: "334"
    },
    {
      label: "335",
      value: "335"
    },
    {
      label: "347",
      value: "347"
    },

    {
      label: "Misc.",
      value: "Misc."
    },

    {
      label: "N-50",
      value: "N-50"
    },
    {
      label: "N-60",
      value: "N-60"
    },
    {
      label: "AL6XN",
      value: "AL6XN"
    },
    {
      label: "254 SMO",
      value: "254 SMO"
    },
    {
      label: "DUPLEX",
      value: "DUPLEX"
    },

    {
      label: "2304",
      value: "2304"
    },
    {
      label: "2507",
      value: "2507"
    },
    {
      label: "2205",
      value: "2205"
    },
    {
      label: "Z 100",
      value: "Z 100"
    },
    {
      label: "Cast 255",
      value: "Cast 255"
    },

    {
      label: "2304",
      value: "2304"
    },
    {
      label: "2507",
      value: "2507"
    },
    {
      label: "2205",
      value: "2205"
    },
    {
      label: "Z 100",
      value: "Z 100"
    },
    {
      label: "Cast 255",
      value: "Cast 255"
    },
    {
      label: "Ni Alloy B",
      value: "Ni Alloy B"
    },

    {
      label: "Ni Alloy C",
      value: "Ni Alloy C"
    },

    {
      label: "Ni Alloy D",
      value: "Ni Alloy D"
    },
    {
      label: "Ni Alloy F",
      value: "Ni Alloy F"
    },
    {
      label: "Ni Alloy G",
      value: "Ni Alloy G"
    },
    {
      label: "Ni Alloy G 30",
      value: "Ni Alloy G 30"
    },
    {
      label: "Ni Alloy X",
      value: "Ni Alloy X"
    },
    {
      label: "Ni Alloy 210",
      value: "Ni Alloy 210"
    },
    {
      label: "Ni Alloy 213",
      value: "Ni Alloy 213"
    },
    {
      label: "Ni Alloy 305",
      value: "Ni Alloy 305"
    },
    {
      label: "Ni-Cr Alloy 610",
      value: "Ni-Cr Alloy 610"
    },
    {
      label: "IN 611",
      value: "IN 611"
    },
    {
      label: "IN 625",
      value: "IN 625"
    },

    {
      label: "50Cr 50Ni",
      value: "50Cr 50Ni"
    },
    {
      label: "60Cr 40Ni",
      value: "60Cr 40Ni"
    },
    {
      label: "IN 657",
      value: "IN 657"
    },
    {
      label: "IN 700",
      value: "IN 700"
    },
    {
      label: "IN 825",
      value: "IN 825"
    },
    {
      label: "N-155",
      value: "N-155"
    },
    {
      label: "INVAR",
      value: "INVAR"
    },
    {
      label: "Ni-Co Alloy Maraging",
      value: "Ni-Co Alloy Maraging"
    },
    {
      label: "INVAR 36",
      value: "INVAR 36"
    },
    {
      label: "Ni-Cu Alloy",
      value: "Ni-Cu Alloy"
    },

    {
      label: "Co. Alloy 3",
      value: "Co. Alloy 3"
    },
    {
      label: "Co. Alloy 4",
      value: "Co. Alloy 4"
    },
    {
      label: "Co. Alloy 6",
      value: "Co. Alloy 6"
    },
    {
      label: "Co. Alloy 7",
      value: "Co. Alloy 7"
    },
    {
      label: "Co. Alloy 12",
      value: "Co. Alloy 12"
    },
    {
      label: "Co. Alloy 19",
      value: "Co. Alloy 19"
    },
    {
      label: "Co. Alloy 21",
      value: "Co. Alloy 21"
    },
    {
      label: "Co. Alloy 22",
      value: "Co. Alloy 22"
    },
    {
      label: "Co. Alloy 23",
      value: "Co. Alloy 23"
    },
    {
      label: "Co. Alloy 25",
      value: "Co. Alloy 25"
    },
    {
      label: "Co. Alloy 27",
      value: "Co. Alloy 27"
    },
    {
      label: "Co. Alloy 30",
      value: "Co. Alloy 30"
    },
    {
      label: "Co. Alloy 31",
      value: "Co. Alloy 31"
    },
    {
      label: "Co. Alloy 32",
      value: "Co. Alloy 32"
    },
    {
      label: "X 40",
      value: "X 40"
    },
    {
      label: "X 45",
      value: "X 45"
    },
    {
      label: "FSX 414",
      value: "FSX 414"
    },
    {
      label: "Co. Alloy 36",
      value: "Co. Alloy 36"
    },
    {
      label: "Co. Alloy 93",
      value: "Co. Alloy 93"
    },
    {
      label: "Co. Alloy T400",
      value: "Co. Alloy T400"
    },
    {
      label: "Co Alloy T800",
      value: "Co Alloy T800"
    },
    {
      label: "CoCrMo",
      value: "CoCrMo"
    },
    {
      label: "Co. Alloy Misc.",
      value: "Co. Alloy Misc."
    },

    {
      label: "HAYNES ULTIMET ALLOY",
      value: "HAYNES ULTIMET ALLOY"
    },
    {
      label: "N-155",
      value: "N-155"
    }
  ]
};

export const airMeltCommonNameOptions = {
  category: "Common Name",
  options: [
    {
      label: "MIL-S-81591 IC 1020",
      value: "MIL-S-81591 IC 1020"
    },
    {
      label: "ASTM A 216 WCC",
      value: "ASTM A 216 WCC"
    },
    {
      label: "ASTM A 352 LCC",
      value: "ASTM A 352 LCC"
    },
    {
      label: "ASTM A 216 WCB",
      value: "ASTM A 216 WCB"
    },
    {
      label: "ASTM A 352 LCB",
      value: "ASTM A 352 LCB"
    },
    {
      label: "MIL-S-22141B/81591 IC 1030",
      value: "MIL-S-22141B/81591 IC 1030"
    },
    {
      label: "MIL-S-22141B/81591 IC 1040",
      value: "MIL-S-22141B/81591 IC 1040"
    },
    {
      label: "MIL-S-22141B/81591 IC 1050",
      value: "MIL-S-22141B/81591 IC 1050"
    },
    {
      label: "ASTM A 352 LC4",
      value: "ASTM A 352 LC4"
    },
    {
      label: "ASTM A 352 LC2",
      value: "ASTM A 352 LC2"
    },
    {
      label: "ASTM 487 GR1",
      value: "ASTM 487 GR1"
    },
    {
      label: "ASTM A 217 WC1",
      value: "ASTM A 217 WC1"
    },
    {
      label: "ASTM A 217 WC9",
      value: "ASTM A 217 WC9"
    },
    {
      label: "ASTM A 217 WC6",
      value: "ASTM A 217 WC6"
    },
    {
      label: "AMS 5336",
      value: "AMS 5336"
    },
    {
      label: "MIL-S-22141B IC 4130",
      value: "MIL-S-22141B IC 4130"
    },
    {
      label: "AMS 5338",
      value: "AMS 5338"
    },
    {
      label: "MIL-S-22141B IC 4140",
      value: "MIL-S-22141B IC 4140"
    },
    {
      label: "AMS 5328",
      value: "AMS 5328"
    },
    {
      label: "MIL-S-22141B IC 4335M",
      value: "MIL-S-22141B IC 4335M"
    },
    {
      label: "AMS 5330",
      value: "AMS 5330"
    },
    {
      label: "MIL-S-22141B IC 4340",
      value: "MIL-S-22141B IC 4340"
    },
    {
      label: "MIL-S-22141B IC 4620",
      value: "MIL-S-22141B IC 4620"
    },
    {
      label: "MIL-S-22141B IC 6150",
      value: "MIL-S-22141B IC 6150"
    },
    {
      label: "AMS 5333",
      value: "AMS 5333"
    },
    {
      label: "MIL-S-22141B IC 8620",
      value: "MIL-S-22141B IC 8620"
    },
    {
      label: "AMS 5334",
      value: "AMS 5334"
    },
    {
      label: "MIL-S-22141B IC 8630",
      value: "MIL-S-22141B IC 8630"
    },
    {
      label: "MIL-S-22141B IC 8635",
      value: "MIL-S-22141B IC 8635"
    },
    {
      label: "MIL-S-22141B IC 8640",
      value: "MIL-S-22141B IC 8640"
    },
    {
      label: "MIL-S-22141B IC 52100",
      value: "MIL-S-22141B IC 52100"
    },
    {
      label: "ASTM A 732 15A",
      value: "ASTM A 732 15A"
    },
    {
      label: "ASTM A 597 CA-2",
      value: "ASTM A 597 CA-2"
    },
    {
      label: "ASTM A 597 CD-2",
      value: "ASTM A 597 CD-2"
    },
    {
      label: "ASTM A 597 CD-5",
      value: "ASTM A 597 CD-5"
    },
    {
      label: "IC CH-11",
      value: "IC CH-11"
    },
    {
      label: "ASTM A 597 CH-12",
      value: "ASTM A 597 CH-12"
    },
    {
      label: "ASTM A 597 CH-13",
      value: "ASTM A 597 CH-13"
    },
    {
      label: "ASTM A 597 cannonMuskegonTitle-2",
      value: "ASTM A 597 cannonMuskegonTitle-2"
    },
    {
      label: "IC cannonMuskegonTitle-4",
      value: "IC cannonMuskegonTitle-4"
    },
    {
      label: "IC cannonMuskegonTitle-42",
      value: "IC cannonMuskegonTitle-42"
    },
    {
      label: "IC cannonMuskegonTitle-43",
      value: "IC cannonMuskegonTitle-43"
    },
    {
      label: "ASTM A 597 CO-1",
      value: "ASTM A 597 CO-1"
    },
    {
      label: "IC CO-2",
      value: "IC CO-2"
    },
    {
      label: "IC CS-2",
      value: "IC CS-2"
    },
    {
      label: "ASTM A 597 CS-5",
      value: "ASTM A 597 CS-5"
    },
    {
      label: "ASTM A 597 CS-7",
      value: "ASTM A 597 CS-7"
    },
    {
      label: "IC CT-1",
      value: "IC CT-1"
    },
    {
      label: "AMS 5340",
      value: "AMS 5340"
    },
    {
      label: "ASTM A 747 CB 7Cu-2",
      value: "ASTM A 747 CB 7Cu-2"
    },
    {
      label: "AMS 5346",
      value: "AMS 5346"
    },
    {
      label: "AMS 5347",
      value: "AMS 5347"
    },
    {
      label: "AMS 5356",
      value: "AMS 5356"
    },
    {
      label: "AMS 5357",
      value: "AMS 5357"
    },
    {
      label: "AMS 5400",
      value: "AMS 5400"
    },
    {
      label: "ASTM A 747 CB 7Cu-1",
      value: "ASTM A 747 CB 7Cu-1"
    },
    {
      label: "AMS 5342/5344",
      value: "AMS 5342/5344"
    },
    {
      label: "AMS 5343",
      value: "AMS 5343"
    },
    {
      label: "AMS 5355",
      value: "AMS 5355"
    },
    {
      label: "MIL-S-81591 IC-17-4",
      value: "MIL-S-81591 IC-17-4"
    },
    {
      label: "AMS 5368",
      value: "AMS 5368"
    },
    {
      label: "AMS 5358",
      value: "AMS 5358"
    },
    {
      label: "MIL-S-81591 IC 302",
      value: "MIL-S-81591 IC 302"
    },
    {
      label: "ASTM A 743 CF20",
      value: "ASTM A 743 CF20"
    },
    {
      label: "AMS 5341",
      value: "AMS 5341"
    },
    {
      label: "MIL-S-81591 IC 303 a",
      value: "MIL-S-81591 IC 303 a"
    },
    {
      label: "MIL-S-81591 IC 303 b",
      value: "MIL-S-81591 IC 303 b"
    },
    {
      label: "ASTM A 743 CF16F",
      value: "ASTM A 743 CF16F"
    },
    {
      label: "ASTM A 743 CF16F A",
      value: "ASTM A 743 CF16F A"
    },
    {
      label: "ASTM A 743/744 CF8",
      value: "ASTM A 743/744 CF8"
    },
    {
      label: "ASTM A 351 CF8/CF8 A",
      value: "ASTM A 351 CF8/CF8 A"
    },
    {
      label: "MIL-S-81591 IC 304",
      value: "MIL-S-81591 IC 304"
    },
    {
      label: "ASTM A 743/744 CF3",
      value: "ASTM A 743/744 CF3"
    },
    {
      label: "ASTM A 351 CF3/CF3A",
      value: "ASTM A 351 CF3/CF3A"
    },
    {
      label: "AMS 5370/5371",
      value: "AMS 5370/5371"
    },
    {
      label: "MIL-S-81591 IC 304L",
      value: "MIL-S-81591 IC 304L"
    },
    {
      label: "ASTM A 351 CF10",
      value: "ASTM A 351 CF10"
    },
    {
      label: "ASTM A 297 HF",
      value: "ASTM A 297 HF"
    },
    {
      label: "DIN 1.4826",
      value: "DIN 1.4826"
    },
    {
      label: "ASTM A 297 HH",
      value: "ASTM A 297 HH"
    },
    {
      label: "ASTM A 351 CH10",
      value: "ASTM A 351 CH10"
    },
    {
      label: "ASTM A 351 CH20",
      value: "ASTM A 351 CH20"
    },
    {
      label: "ASTM A 351 HK30",
      value: "ASTM A 351 HK30"
    },
    {
      label: "ASTM A 351 HK40",
      value: "ASTM A 351 HK40"
    },
    {
      label: "AMS 5365",
      value: "AMS 5365"
    },
    {
      label: "AMS 5366",
      value: "AMS 5366"
    },
    {
      label: "MIL-S-81591 IC 310",
      value: "MIL-S-81591 IC 310"
    },
    {
      label: "ASTM A 743 CK20",
      value: "ASTM A 743 CK20"
    },
    {
      label: "ASTM A 297 HK",
      value: "ASTM A 297 HK"
    },
    {
      label: "ASTM A 297 HL",
      value: "ASTM A 297 HL"
    },
    {
      label: "ASTM A 351 CK20",
      value: "ASTM A 351 CK20"
    },
    {
      label: "ASTM A 297 HN",
      value: "ASTM A 297 HN"
    },
    {
      label: "ASTM A 743 CE30",
      value: "ASTM A 743 CE30"
    },
    {
      label: "ASTM A 297 HE",
      value: "ASTM A 297 HE"
    },
    {
      label: "AMS 5360",
      value: "AMS 5360"
    },
    {
      label: "AMS 5361",
      value: "AMS 5361"
    },
    {
      label: "MIL-S-81591 IC 316",
      value: "MIL-S-81591 IC 316"
    },
    {
      label: "ASTM A 351",
      value: "ASTM A 351"
    },
    {
      label: "ASTM 743/744 CF8M",
      value: "ASTM 743/744 CF8M"
    },
    {
      label: "F-745",
      value: "F-745"
    },
    {
      label: "ASTM A 351 CF3M/CF3MA",
      value: "ASTM A 351 CF3M/CF3MA"
    },
    {
      label: "ASTM A 743/744 CF3M",
      value: "ASTM A 743/744 CF3M"
    },
    {
      label: "ISO 5832-1",
      value: "ISO 5832-1"
    },
    {
      label: "ASTM A 351/743 CF3MN",
      value: "ASTM A 351/743 CF3MN"
    },
    {
      label: "ASTM A 351 CF 10M",
      value: "ASTM A 351 CF 10M"
    },
    {
      label: "ASTM A 351/743/744 CG8M",
      value: "ASTM A 351/743/744 CG8M"
    },
    {
      label: "MIL-S-81591 IC 321",
      value: "MIL-S-81591 IC 321"
    },
    {
      label: "ASTM A 297 HD",
      value: "ASTM A 297 HD"
    },
    {
      label: "ASTM A 297 HT",
      value: "ASTM A 297 HT"
    },
    {
      label: "ASTM A 351 HT30",
      value: "ASTM A 351 HT30"
    },
    {
      label: "ASTM A 297 HU",
      value: "ASTM A 297 HU"
    },
    {
      label: "ASTM A 297 HW",
      value: "ASTM A 297 HW"
    },
    {
      label: "ASTM A 297 HX",
      value: "ASTM A 297 HX"
    },
    {
      label: "ASTM A 743/744 CF8C",
      value: "ASTM A 743/744 CF8C"
    },
    {
      label: "ASTM A 351 CF8C",
      value: "ASTM A 351 CF8C"
    },
    {
      label: "AMS 5362",
      value: "AMS 5362"
    },
    {
      label: "AMS 5364",
      value: "AMS 5364"
    },
    {
      label: "MIL-S-867A CL II",
      value: "MIL-S-867A CL II"
    },
    {
      label: "MIL-S-81591 IC 347",
      value: "MIL-S-81591 IC 347"
    },
    {
      label: "ASTM A 297 HI",
      value: "ASTM A 297 HI"
    },
    {
      label: "ASTM A 297 HP",
      value: "ASTM A 297 HP"
    },
    {
      label: "ASTM A 351 CT 15C",
      value: "ASTM A 351 CT 15C"
    },
    {
      label: "ASTM A 351/743/744 CN7M",
      value: "ASTM A 351/743/744 CN7M"
    },
    {
      label: "ASTM A 743/744 CN7MS",
      value: "ASTM A 743/744 CN7MS"
    },
    {
      label: "ASTM A 743 CN3M",
      value: "ASTM A 743 CN3M"
    },
    {
      label: "ASTM A 351 CF10MC",
      value: "ASTM A 351 CF10MC"
    },
    {
      label: "IN 864/856",
      value: "IN 864/856"
    },
    {
      label: "AMS 5369",
      value: "AMS 5369"
    },
    {
      label: "ASTM A 990 CN3MCu",
      value: "ASTM A 990 CN3MCu"
    },
    {
      label: "ASTM A 351/743 CG6MMN",
      value: "ASTM A 351/743 CG6MMN"
    },
    {
      label: "ASTM A 351/743 CF10SMnN",
      value: "ASTM A 351/743 CF10SMnN"
    },
    {
      label: "ASTM A 743/744 CN3MN",
      value: "ASTM A 743/744 CN3MN"
    },
    {
      label: "O ASTM A 351/743/744 CK3MCuN",
      value: "O ASTM A 351/743/744 CK3MCuN"
    },
    {
      label: "ASTM A 890 1A CD4MCu",
      value: "ASTM A 890 1A CD4MCu"
    },
    {
      label: "ASTM A 890/995 1B CD4MCuN",
      value: "ASTM A 890/995 1B CD4MCuN"
    },
    {
      label: "ASTM A 890 1C CD3MCuN",
      value: "ASTM A 890 1C CD3MCuN"
    },
    {
      label: "ASTM A 890/351/995 2A CE8MN",
      value: "ASTM A 890/351/995 2A CE8MN"
    },
    {
      label: "ASTM A 890/995 3A CD6MN",
      value: "ASTM A 890/995 3A CD6MN"
    },
    {
      label: "ASTM A 890/995 4A CD3MN",
      value: "ASTM A 890/995 4A CD3MN"
    },
    {
      label: "ASTM A 890/995 5A CE3MN",
      value: "ASTM A 890/995 5A CE3MN"
    },
    {
      label: "ASTM A 890/995 6A CD3MWCuN",
      value: "ASTM A 890/995 6A CD3MWCuN"
    },
    {
      label: "X2CrNiN23-4",
      value: "X2CrNiN23-4"
    },
    {
      label: "X2CrNiMoN25-7-4",
      value: "X2CrNiMoN25-7-4"
    },
    {
      label: "X2CrNiMoN22-5-3",
      value: "X2CrNiMoN22-5-3"
    },
    {
      label: "X2CrNiMoCuWN25-7-4",
      value: "X2CrNiMoCuWN25-7-4"
    },
    {
      label: "X2CrNiMoCuN25-6-3",
      value: "X2CrNiMoCuN25-6-3"
    },
    {
      label: "ASTM A 890 1A CD4MCu",
      value: "ASTM A 890 1A CD4MCu"
    },
    {
      label: "ASTM A 890/995 1B CD4MCuN",
      value: "ASTM A 890/995 1B CD4MCuN"
    },
    {
      label: "ASTM A 890 1C CD3MCuN",
      value: "ASTM A 890 1C CD3MCuN"
    },
    {
      label: "ASTM A 890/351/995 2A CE8MN",
      value: "ASTM A 890/351/995 2A CE8MN"
    },
    {
      label: "ASTM A 890/995 3A CD6MN",
      value: "ASTM A 890/995 3A CD6MN"
    },
    {
      label: "ASTM A 890/995 4A CD3MN",
      value: "ASTM A 890/995 4A CD3MN"
    },
    {
      label: "ASTM A 890/995 5A CE3MN",
      value: "ASTM A 890/995 5A CE3MN"
    },
    {
      label: "ASTM A 890/995 6A CD3MWCuN",
      value: "ASTM A 890/995 6A CD3MWCuN"
    },
    {
      label: "X2CrNiN23-4",
      value: "X2CrNiN23-4"
    },
    {
      label: "X2CrNiMoN25-7-4",
      value: "X2CrNiMoN25-7-4"
    },
    {
      label: "X2CrNiMoN22-5-3",
      value: "X2CrNiMoN22-5-3"
    },
    {
      label: "X2CrNiMoCuWN25-7-4",
      value: "X2CrNiMoCuWN25-7-4"
    },
    {
      label: "X2CrNiMoCuN25-6-3",
      value: "X2CrNiMoCuN25-6-3"
    },
    {
      label: "AMS 5396",
      value: "AMS 5396"
    },
    {
      label: "ASTM A 494 N12MV",
      value: "ASTM A 494 N12MV"
    },
    {
      label: "ASTM A 494 N7M",
      value: "ASTM A 494 N7M"
    },
    {
      label: "ASTN A 494 N3M",
      value: "ASTN A 494 N3M"
    },
    {
      label: "AMS 5388",
      value: "AMS 5388"
    },
    {
      label: "AMS 5389",
      value: "AMS 5389"
    },
    {
      label: "ASTM A 494 CW12MW",
      value: "ASTM A 494 CW12MW"
    },
    {
      label: "ASTM A 494 CW6M",
      value: "ASTM A 494 CW6M"
    },
    {
      label: "ASTM A 494 CW2M",
      value: "ASTM A 494 CW2M"
    },
    {
      label: "ASTM A 494 CX2M",
      value: "ASTM A 494 CX2M"
    },
    {
      label: "ASTM A 494 CX2MW",
      value: "ASTM A 494 CX2MW"
    },
    {
      label: "UNS-N06001",
      value: "UNS-N06001"
    },
    {
      label: "UNS-N06007",
      value: "UNS-N06007"
    },
    {
      label: "UNS-N06030",
      value: "UNS-N06030"
    },
    {
      label: "AMS 5390",
      value: "AMS 5390"
    },
    {
      label: "ASTM A 494 CZ100",
      value: "ASTM A 494 CZ100"
    },

    {
      label: "ASTM A 494 CY40",
      value: "ASTM A 494 CY40"
    },

    {
      label: "AMS 5402",
      value: "AMS 5402"
    },
    {
      label: "ASTM A 494 CW6MC",
      value: "ASTM A 494 CW6MC"
    },
    {
      label: "ASTM A 560 50 Cr-50 Ni",
      value: "ASTM A 560 50 Cr-50 Ni"
    },
    {
      label: "ASTM A 560 60 Cr-40 Ni",
      value: "ASTM A 560 60 Cr-40 Ni"
    },
    {
      label: "ASTM A 560 50 Cr-50 Ni-Cb",
      value: "ASTM A 560 50 Cr-50 Ni-Cb"
    },

    {
      label: "ASTM A 494 CU5MCuC",
      value: "ASTM A 494 CU5MCuC"
    },
    {
      label: "AMS 5376",
      value: "AMS 5376"
    },
    {
      label: "MIL-I-23011C CLASS 5",
      value: "MIL-I-23011C CLASS 5"
    },
    {
      label: "IC 47 50",
      value: "IC 47 50"
    },
    {
      label: "AMS 5339",
      value: "AMS 5339"
    },

    {
      label: "AMS 5387",
      value: "AMS 5387"
    },
    {
      label: "AMS 5373",
      value: "AMS 5373"
    },

    {
      label: "AMS 5385",
      value: "AMS 5385"
    },
    {
      label: "ASTM A 732 GR 21",
      value: "ASTM A 732 GR 21"
    },
    {
      label: "AMS 5375",
      value: "AMS 5375"
    },
    {
      label: "HS 25 (L605)",
      value: "HS 25 (L605)"
    },
    {
      label: "AMS 5378",
      value: "AMS 5378"
    },
    {
      label: "AMS 5380",
      value: "AMS 5380"
    },
    {
      label: "AMS 5382",
      value: "AMS 5382"
    },
    {
      label: "ASTM A 732 GR 31",
      value: "ASTM A 732 GR 31"
    },
    {
      label: "ASTM A 567 GR 2 (Disc.-1987)",
      value: "ASTM A 567 GR 2 (Disc.-1987)"
    },
    {
      label: "ASTM A 567 GR 13 (Disc-1987)",
      value: "ASTM A 567 GR 13 (Disc-1987)"
    },
    {
      label: "ASTM A567 GR 12 (Disc-1987)",
      value: "ASTM A567 GR 12 (Disc-1987)"
    },

    {
      label: "ASTM F75",
      value: "ASTM F75"
    },
    {
      label: "ISO 5832-4",
      value: "ISO 5832-4"
    },
    {
      label: "STAR J",
      value: "STAR J"
    },
    {
      label: "98M2",
      value: "98M2"
    },
    {
      label: "WI-52",
      value: "WI-52"
    },
    {
      label: "TANTUNG G",
      value: "TANTUNG G"
    },
    {
      label: "UNS-R31233",
      value: "UNS-R31233"
    },
    {
      label: "AMS 5376",
      value: "AMS 5376"
    }
  ]
};

export const airMeltTradeNameOptions = {
  category: "Trade Name",
  options: [
    {
      label: "14-4 PH",
      value: "14-4 PH"
    },
    {
      label: "15-5 PH",
      value: "15-5 PH"
    },
    {
      label: "17-4 PH",
      value: "17-4 PH"
    },
    {
      label: "302",
      value: "302"
    },
    {
      label: "303",
      value: "303"
    },
    {
      label: "304",
      value: "304"
    },
    {
      label: "304L",
      value: "304L"
    },
    {
      label: "Alloy 20",
      value: "Alloy 20"
    },

    {
      label: "Nitronic 50",
      value: "Nitronic 50"
    },
    {
      label: "Nitronic 60",
      value: "Nitronic 60"
    },
    {
      label: "AL-6XN",
      value: "AL-6XN"
    },
    {
      label: "254 SMO",
      value: "254 SMO"
    },
    {
      label: "25-5",
      value: "25-5"
    },

    {
      label: "Cast Ferralium",
      value: "Cast Ferralium"
    },
    {
      label: "ES 45 D",
      value: "ES 45 D"
    },

    {
      label: "2205",
      value: "2205"
    },
    {
      label: "2507",
      value: "2507"
    },
    {
      label: "Z 100",
      value: "Z 100"
    },

    {
      label: "B",
      value: "B"
    },
    {
      label: "B2",
      value: "B2"
    },

    {
      label: "C276",
      value: "C276"
    },

    {
      label: "C4C",
      value: "C4C"
    },
    {
      label: "C2000",
      value: "C2000"
    },
    {
      label: "C22",
      value: "C22"
    },

    {
      label: "HASTELLOY G",
      value: "HASTELLOY G"
    },
    {
      label: "HASTELLOY G30",
      value: "HASTELLOY G30"
    },
    {
      label: "HASTELLOY X",
      value: "HASTELLOY X"
    },

    {
      label: "IN 610",
      value: "IN 610"
    },
    {
      label: "IN 825",
      value: "IN 825"
    },
    {
      label: "Multimet",
      value: "Multimet"
    },

    {
      label: "INVAR 36",
      value: "INVAR 36"
    },
    {
      label: "MONEL S 505",
      value: "MONEL S 505"
    },
    {
      label: "MONEL 411",
      value: "MONEL 411"
    },
    {
      label: "MONEL 506",
      value: "MONEL 506"
    },
    {
      label: "MONEL",
      value: "MONEL"
    },
    {
      label: "MONEL 410",
      value: "MONEL 410"
    },
    {
      label: "Stellite 3",
      value: "Stellite 3"
    },
    {
      label: "Stellite 4",
      value: "Stellite 4"
    },
    {
      label: "Stellite 6",
      value: "Stellite 6"
    },

    {
      label: "Stellite 12",
      value: "Stellite 12"
    },
    {
      label: "Stellite 19",
      value: "Stellite 19"
    },
    {
      label: "Stellite 21",
      value: "Stellite 21"
    },

    {
      label: "Stellite 23",
      value: "Stellite 23"
    },

    {
      label: "Stellite 27",
      value: "Stellite 27"
    },
    {
      label: "Stellite 30",
      value: "Stellite 30"
    },
    {
      label: "Stellite 31",
      value: "Stellite 31"
    },
    {
      label: "T 400",
      value: "T 400"
    },
    {
      label: "T 800",
      value: "T 800"
    },
    {
      label: "F 75",
      value: "F 75"
    },
    {
      label: "F 75",
      value: "F 75"
    },
    {
      label: "STAR J",
      value: "STAR J"
    },

    {
      label: "Ultimet",
      value: "Ultimet"
    }
  ]
};

export const airMeltAstmOptions = {
  category: "ASTM",
  options: [
    {
      label: "A 747 CB 7Cu-2",
      value: "A 747 CB 7Cu-2"
    },
    {
      label: "A 747 CB 7Cu-1",
      value: "A 747 CB 7Cu-1"
    },
    {
      label: "ASTM A 743 CF20",
      value: "ASTM A 743 CF20"
    },
    {
      label: "A 743 CF16F A",
      value: "A 743 CF16F A"
    },
    {
      label: "A 743/744 CF8",
      value: "A 743/744 CF8"
    },
    {
      label: "A 743/744 CF3",
      value: "A 743/744 CF3"
    },
    {
      label: "A 890 1A CD4MCu",
      value: "A 890 1A CD4MCu"
    },
    {
      label: "890/995 1B CD4MCuN",
      value: "890/995 1B CD4MCuN"
    },
    {
      label: "890 1C CD3MCuN",
      value: "890 1C CD3MCuN"
    },
    {
      label: "A 890/351/995 2A CE8MN",
      value: "A 890/351/995 2A CE8MN"
    },
    {
      label: "A 890/995 3A CD6MN",
      value: "A 890/995 3A CD6MN"
    },
    {
      label: "A 890/995 4A CD3MN",
      value: "A 890/995 4A CD3MN"
    },
    {
      label: "A 890/995 5A CE3MN",
      value: "A 890/995 5A CE3MN"
    },
    {
      label: "A 890/995 6A CD3MWCuN",
      value: "A 890/995 6A CD3MWCuN"
    },
    {
      label: "A 494 N12MV",
      value: "A 494 N12MV"
    },
    {
      label: "A 494 N7M",
      value: "A 494 N7M"
    },
    {
      label: "A 494 CW6M",
      value: "A 494 CW6M"
    },
    {
      label: "A 494 CW2M",
      value: "A 494 CW2M"
    },
    {
      label: "A 494 CY40",
      value: "A 494 CY40"
    },
    {
      label: "A 494 CW6MC",
      value: "A 494 CW6MC"
    },
    {
      label: "A 560 50 Cr-50 Ni",
      value: "A 560 50 Cr-50 Ni"
    },
    {
      label: "A 560 60 Cr-40 Ni",
      value: "A 560 60 Cr-40 Ni"
    },
    {
      label: "A 494 CU5MCuC",
      value: "A 494 CU5MCuC"
    },
    {
      label: "A 494 M25S",
      value: "A 494 M25S"
    },
    {
      label: "A 494 M30C",
      value: "A 494 M30C"
    },
    {
      label: "A 494 M30H",
      value: "A 494 M30H"
    },
    {
      label: "A 494 M-35-1",
      value: "A 494 M-35-1"
    },
    {
      label: "A 494 M-35-2",
      value: "A 494 M-35-2"
    },
    {
      label: "A 732 GR 21",
      value: "A 732 GR 21"
    },
    {
      label: "A 732 GR 31",
      value: "A 732 GR 31"
    }
  ]
};

export const airMeltAmsOptions = {
  category: "AMS",
  options: [
    {
      label: "5340",
      value: "5340"
    },
    {
      label: "5432",
      value: "5432"
    },
    {
      label: "5355",
      value: "5355"
    },
    {
      label: "5358",
      value: "5358"
    },
    {
      label: "5341",
      value: "5341"
    },
    {
      label: "5370/5371",
      value: "5370/5371"
    },
    {
      label: "5396",
      value: "5396"
    },
    {
      label: "5397",
      value: "5397"
    },
    {
      label: "5388",
      value: "5388"
    },
    {
      label: "5390",
      value: "5390"
    },
    {
      label: "5402",
      value: "5402"
    },
    {
      label: "5376",
      value: "5376"
    },
    {
      label: "5339",
      value: "5339"
    },
    {
      label: "5387",
      value: "5387"
    },
    {
      label: "7238",
      value: "7238"
    },
    {
      label: "5385",
      value: "5385"
    },
    {
      label: "5375",
      value: "5375"
    },
    {
      label: "5378",
      value: "5378"
    },
    {
      label: "5380",
      value: "5380"
    },
    {
      label: "5382",
      value: "5382"
    }
  ]
};

export const airMeltUnsOptions = {
  category: "UNS",
  options: [
    {
      label: "J92240",
      value: "J92240"
    },
    {
      label: "J92110",
      value: "J92110"
    },
    {
      label: "J92180",
      value: "J92180"
    },
    {
      label: "J92602",
      value: "J92602"
    },
    {
      label: "J92701",
      value: "J92701"
    },
    {
      label: "J92600",
      value: "J92600"
    },
    {
      label: "J92500",
      value: "J92500"
    },
    {
      label: "N08007",
      value: "N08007"
    },
    {
      label: "J94650",
      value: "J94650"
    },
    {
      label: "J93790",
      value: "J93790"
    },
    {
      label: "J93254",
      value: "J93254"
    },
    {
      label: "J94651",
      value: "J94651"
    },
    {
      label: "J93254",
      value: "J93254"
    },
    {
      label: "J93370",
      value: "J93370"
    },
    {
      label: "J93372",
      value: "J93372"
    },
    {
      label: "J93373",
      value: "J93373"
    },
    {
      label: "J93345",
      value: "J93345"
    },
    {
      label: "J93371",
      value: "J93371"
    },
    {
      label: "J92205",
      value: "J92205"
    },
    {
      label: "J93404",
      value: "J93404"
    },
    {
      label: "J93380",
      value: "J93380"
    },
    {
      label: "N30012",
      value: "N30012"
    },
    {
      label: "N30007",
      value: "N30007"
    },
    {
      label: "N30002",
      value: "N30002"
    },
    {
      label: "N30107",
      value: "N30107"
    },
    {
      label: "N26455",
      value: "N26455"
    },
    {
      label: "N06200",
      value: "N06200"
    },
    {
      label: "N26022",
      value: "N26022"
    },
    {
      label: "N06007",
      value: "N06007"
    },
    {
      label: "N06030",
      value: "N06030"
    },
    {
      label: "N06002",
      value: "N06002"
    },
    {
      label: "N02100",
      value: "N02100"
    },
    {
      label: "N06040",
      value: "N06040"
    },
    {
      label: "N26625",
      value: "N26625"
    },
    {
      label: "R20500",
      value: "R20500"
    },
    {
      label: "R20600",
      value: "R20600"
    },
    {
      label: "N08826",
      value: "N08826"
    },
    {
      label: "R30155",
      value: "R30155"
    },
    {
      label: "J93010",
      value: "J93010"
    },
    {
      label: "K93601",
      value: "K93601"
    },
    {
      label: "N24025",
      value: "N24025"
    },
    {
      label: "N24130",
      value: "N24130"
    },
    {
      label: "N24030",
      value: "N24030"
    },
    {
      label: "N24135",
      value: "N24135"
    },
    {
      label: "N04020",
      value: "N04020"
    },
    {
      label: "R30103",
      value: "R30103"
    },
    {
      label: "R30404",
      value: "R30404"
    },
    {
      label: "R30006",
      value: "R30006"
    },
    {
      label: "R30012",
      value: "R30012"
    },
    {
      label: "R30021",
      value: "R30021"
    },
    {
      label: "R30023",
      value: "R30023"
    },
    {
      label: "R30605",
      value: "R30605"
    },
    {
      label: "R30027",
      value: "R30027"
    },
    {
      label: "R30030",
      value: "R30030"
    },
    {
      label: "R30031",
      value: "R30031"
    },
    {
      label: "R30400",
      value: "R30400"
    },
    {
      label: "R30075",
      value: "R30075"
    },
    {
      label: "R30102",
      value: "R30102"
    },
    {
      label: "R31233",
      value: "R31233"
    }
  ]
};

export const airMeltDinOptions = {
  category: "DIN",
  options: [
    {
      label: "X5 CrNiCu 15-5",
      value: "X5 CrNiCu 15-5"
    },
    {
      label: "X5 CrNiCuNb 14-4",
      value: "X5 CrNiCuNb 14-4"
    },
    {
      label: "G-X25 CrNiSi 18 9",
      value: "G-X25 CrNiSi 18 9"
    },
    {
      label: "X10CrNiS18-9",
      value: "X10CrNiS18-9"
    },
    {
      label: "G-X6 CrNi 18 9",
      value: "G-X6 CrNi 18 9"
    },
    {
      label: "G-X2 CrNi 18 9",
      value: "G-X2 CrNi 18 9"
    },
    {
      label: "X2CrNiMoCuN25-6-3",
      value: "X2CrNiMoCuN25-6-3"
    },
    {
      label: "X2CrNiMoCuN22-5-3",
      value: "X2CrNiMoCuN22-5-3"
    },
    {
      label: "GX2CrNiMoN25-7-4",
      value: "GX2CrNiMoN25-7-4"
    },
    {
      label: "X2CrNiMoCuWN25-7-4",
      value: "X2CrNiMoCuWN25-7-4"
    },
    {
      label: "X2CrNiN23-4",
      value: "X2CrNiN23-4"
    },
    {
      label: "2.4602",
      value: "2.4602"
    },
    {
      label: "2.4665",
      value: "2.4665"
    },
    {
      label: "2.4856",
      value: "2.4856"
    },
    {
      label: "1.4971",
      value: "1.4971"
    }
  ]
};

export const airMeltWnrOptions = {
  category: "W.-Nr.",
  options: [
    {
      label: "1.4545",
      value: "1.4545"
    },
    {
      label: "1.4542",
      value: "1.4542"
    },
    {
      label: "1.4825",
      value: "1.4825"
    },
    {
      label: "1.4305",
      value: "1.4305"
    },
    {
      label: "1.4308",
      value: "1.4308"
    },
    {
      label: "1.4306",
      value: "1.4306"
    },
    {
      label: "1.4468",
      value: "1.4468"
    },
    {
      label: "1.4462",
      value: "1.4462"
    },
    {
      label: "1.4469",
      value: "1.4469"
    },
    {
      label: "1.4508",
      value: "1.4508"
    },
    {
      label: "1.4362",
      value: "1.4362"
    }
  ]
};

export const airMeltAfnorOptions = {
  category: "AFNOR",
  options: [
    {
      label: "Z4CNUNb 16 4 M",
      value: "Z4CNUNb 16 4 M"
    },
    {
      label: "Z8CNF18-09",
      value: "Z8CNF18-09"
    },

    {
      label: "Z6 CN 18 10 M",
      value: "Z6 CN 18 10 M"
    },

    {
      label: "Z2 CN 18 10 M",
      value: "Z2 CN 18 10 M"
    },

    {
      label: "WFe32C20DU",
      value: "WFe32C20DU"
    },

    {
      label: "QQN 288 Comp C& D",
      value: "QQN 288 Comp C& D"
    },
    {
      label: "QQN 288 Comp E",
      value: "QQN 288 Comp E"
    },
    {
      label: "QQN 288 Comp B",
      value: "QQN 288 Comp B"
    },

    {
      label: "QQN 288 Comp A",
      value: "QQN 288 Comp A"
    }
  ]
};

export const AIR_MELT_INDUSTRY_OPTIONS: AirMeltIndustryInfo[] = [
  airMeltCmOptions,
  airMeltCommonNameOptions,
  airMeltTradeNameOptions,
  airMeltAstmOptions,
  airMeltAmsOptions,
  airMeltUnsOptions,
  airMeltDinOptions,
  airMeltWnrOptions,
  airMeltAfnorOptions
];
